export const listingDetail = {
  breadcrumb: {
    listings: "الإعلانات",
    detailFallback: "التفاصيل",
  },
  hero: {
    noName: "بدون اسم",
    editNameTitle: "تعديل الاسم",
    channelConnected: "متصل بالقناة (منصات الحجز)",
    channelDisconnected: "غير متصل بالقناة",
  },
  units: {
    unitsCount: "{count} وحدات",
    roomsCount: "{count} غرفة | {count} غرف",
    maxGuests: "الحد الأقصى {count} نزيل",
    searchPlaceholder: "ابحث عن وحدة…",
    dragTitle: "اسحب لإعادة الترتيب",
    headerRoomTypes: "أنواع الغرف",
    headerLinkedUnits: "الوحدات المرتبطة",
    addBtnTitle: "إضافة وحدة",
    movedBadge: "تم النقل",
    unitFallback: "وحدة",
  },
  typeLabels: {
    apartment: "شقة",
    house: "منزل",
    villa: "فيلا",
    hotel: "فندق",
    room: "غرفة",
    studio: "استوديو",
    fallback: "مكان إقامة",
  },
  aiReception: {
    title: "استقبال بالذكاء الاصطناعي",
  },
  toggles: {
    enableAgent: {
      label: "تفعيل وكيل الذكاء الاصطناعي",
      hint: "يؤتمت خدمة نزلائك عبر واتساب.",
    },
    otaAgent: {
      label: "وكيل الذكاء الاصطناعي لمنصات الحجز",
      hintOn: "يرد أيضاً على رسائل Booking وAirbnb ومنصات الحجز الأخرى.",
      hintOff: "يتطلب تفعيل وكيل الذكاء الاصطناعي.",
    },
  },
  status: {
    active: "مُفعّل",
    inactive: "مُعطّل",
  },
  emptyUnits: {
    title: "لا توجد وحدات",
    subHotel: "أنشئ أول غرفة أو وحدة لهذا الفندق للبدء في ضبط الأسعار والإتاحة.",
    subDefault: "أضف أول وحدة إلى هذا الإعلان لبدء استقبال النزلاء.",
    ctaPreparing: "جارٍ التحضير…",
    ctaAddRoom: "إضافة غرفة",
    ctaAddFirstUnit: "إضافة أول وحدة",
  },
  sortBar: {
    add: "إضافة",
    addRoom: "إضافة غرفة",
    saving: "جارٍ الحفظ…",
    done: "تم",
    sort: "ترتيب",
    dragHint: "اسحب لإعادة الترتيب",
  },
  propOptions: {
    scheduled: "الرسائل المجدولة",
    services: "التجهيزات ووسائل الراحة",
    locks: "الأقفال",
    faq: "الأسئلة والأجوبة",
    arrival: "تعليمات الوصول",
    checkout: "رسالة المغادرة",
    welcome: "رسالة الترحيب",
    description: "الوصف",
    capacity: "السعة",
  },
  addZone: {
    titleRoom: "إضافة غرفة",
    titleUnit: "إضافة وحدة",
    roomLower: "غرفة",
    unitLower: "وحدة",
    createNew: "أنشئ {noun} جديدة داخل",
    eachHas: "لكل {noun} إعداداتها الخاصة (الوصف، السعة، طرق الدخول…).",
    ctaPreparing: "جارٍ التحضير…",
    ctaCreateRoom: "إنشاء غرفة",
    ctaCreateUnit: "إنشاء وحدة",
  },
  danger: {
    deleteListing: "حذف الإعلان...",
    notePrefix: "يحذف الإعلان",
    noteSuffix: " وجميع وحداته من WACheckin. لا يمكن التراجع عن هذا الإجراء.",
  },
  toast: {
    orderSaved: "تم حفظ الترتيب بنجاح",
  },
  errors: {
    loadListing: "تعذّر تحميل مكان الإقامة.",
  },
  authorities: {
    title: "السلطات",
    description: "اضبط الاتصال بالسلطات المحلية لإرسال بيانات النزلاء تلقائياً.",
  },
  cards: {
    knowledge: { title: "قاعدة المعرفة", status: "المعلومات التي يستخدمها الوكيل" },
    earlyAccess: { title: "الوصول المبكر", status: "مواعيد الوصول وتسجيل الوصول المبكر" },
    lateCheckout: { title: "تسجيل مغادرة متأخر", status: "المغادرة المتأخرة والسعر" },
    extendStay: { title: "تمديد الإقامة", status: "تمديد ليالي الحجز" },
    invoicing: { title: "إصدار الفواتير", status: "البيانات الضريبية · متوافق مع Verifactu" },
    location: { title: "الموقع", sub: "عنوان مكان الإقامة" },
    logo: { title: "العلامة التجارية", sub: "الهوية البصرية" },
    welcome: { title: "رسالة الترحيب", sub: "خصّص رسالة الترحيب" },
    checkin: { title: "تسجيل الوصول", sub: "التعليمات ومواعيد الدخول" },
    policies: { title: "سياسات مكان الإقامة", sub: "القواعد والشروط" },
    authorities: { sub: "التسجيل لدى السلطات" },
    hotelRates: { title: "أسعار الفندق", sub: "الأسعار الأساسية والمشتقة" },
    roomManagement: { title: "الغرف", sub: "أنواع الغرف والمخزون" },
    rates: { title: "الأسعار", sub: "الأسعار الأساسية والمشتقة" },
    ota: { title: "ربط منصة حجز", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "يتطلب اشتراكاً نشطاً" },
    ical: { title: "تقويم iCal", sub: "مزامنة التقاويم" },
    ownerSettlement: { title: "المالك والتسوية", sub: "إذا كنت تديره لمالك آخر: العمولة والتسوية", subManaged: "تديره لصالح {owner} · {pct}%", subManagedNoOwner: "مُدار · {pct}% · دون مالك محدّد" },
    otaCommissions: { title: "عمولات منصات الحجز", sub: "ما تقتطعه كل منصة وما يصلك", subActive: "تعرض بطاقة الحجز ما يصلك من كل حجز" },
    description: { title: "الوصف", sub: "تفاصيل الوحدة" },
    capacity: { title: "السعة", sub: "النزلاء والأسرّة" },
    services: { title: "التجهيزات ووسائل الراحة", sub: "ما يقدمه، مع الصور" },
    unitFaq: { title: "الأسئلة والأجوبة", sub: "خاصة بهذه الوحدة من أجل الوكيل" },
    rules: { title: "المواعيد", sub: "مواعيد الدخول والخروج" },
    upselling: { title: "التجارب والخدمات", sub: "خدمات البيع الإضافي" },
    checkinStore: { title: "متجر تسجيل الوصول", sub: "أرسله للضيف عند الوصول" },
    bookingConfirmation: { title: "إشعار بحجز جديد", sub: "نُعلم النزيل عبر واتساب عند تأكيد حجزه" },
    arrivalInstructions: { title: "تعليمات الوصول", sub: "كيفية الوصول والدخول · مع وقت الإرسال" },
    checkoutMessage: { title: "رسالة المغادرة", sub: "تذكير بالمغادرة · قالب" },
    scheduledMessages: { title: "الرسائل المجدولة", sub: "رسائل تلقائية قبل الإقامة وأثناءها وبعدها" },
    review: { title: "طلب تقييم", sub: "سمعة مكان الإقامة" },
    identity: { title: "التحقق من الهوية", sub: "أمان النزيل" },
    journeySim: { title: "محاكاة رحلة النزيل", sub: "يعيد تمثيل العملية كاملة عبر واتساب · أرسلها إلى هاتف للاختبار" },
    smartlocks: { title: "الأقفال والدخول", sub: "كيف يدخل النزيل" },
    integrations: { title: "الاتصالات والتكاملات", sub: "واجهات برمجية واتصالات إضافية" },
    welcomeInline: { sub: "رسالة خاصة بهذه الوحدة" },
    newBookings: { title: "حجوزات جديدة" },
  },
  badges: {
    ai: "ذكاء اصطناعي",
    setup: "إعداد",
    hotel: "فندق",
    subscription: "اشتراك",
    comingSoon: "قريباً",
    test: "اختبار",
    manager: "مدير",
    active: "مفعّل",
  },
  sections: {
    essential: { title: "الإعدادات الأساسية", description: "الإعدادات الأساسية اللازمة لنشر مكان الإقامة وإدارته." },
    management: { title: "إدارة مكان الإقامة", description: "اضبط الأسعار والإتاحة وقنوات البيع." },
    direct: { title: "فصّل هذه الوحدة", description: "معلومات إضافية نستخدمها للحجوزات المباشرة ولتغذية وكيل الذكاء الاصطناعي." },
    guest: { title: "تجربة النزيل", description: "اضبط التواصل قبل الإقامة وأثناءها وبعدها." },
    access: { title: "الدخول والتكاملات", description: "إدارة طرق الدخول والأقفال والاتصالات الخارجية." },
  },
  otaModal: {
    title: "الاتصال بمنصات الحجز",
    html: "يتطلب ربط Booking وAirbnb وVrbo وExpedia (مدير القنوات) <b>اشتراكاً نشطاً</b>.<br><small>في هذه الأثناء يمكنك استخدام باقي الوظائف ومزامنة التقاويم عبر iCal (مجاناً).</small>",
    confirm: "تفعيل الاشتراك",
    cancel: "ليس الآن",
  },
};
